/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ContactUs
 */
export interface ContactUs {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactUs
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContactUs
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    adminNotes: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUs
     */
    status: ContactUsStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContactUsStatusEnum {
    Pending = 'Pending',
    Read = 'Read',
    Resolved = 'Resolved',
    Archived = 'Archived'
}

